describe("ClippingPlanesMixin", function () {
  it("can create a simple clipping planes collection");
  it("can create a box clipping planes collection");
  it("can create box clipping plane graphics");
});